import React, { Component } from 'react';
import { Button } from 'antd-mobile'
import { debounce } from '../../utils/util'
import './index.scss';
import wx from 'weixin-js-sdk';

var browser = {
  versions: function () {
    var u = navigator.userAgent;
    return {
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1, //android终端
    };
  }(),
}

class YsfTipPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
     
    }
    this.onSubmit = debounce(this.onSubmit, 1000)

  }
  componentDidMount() {
    document.title = "提示"
   
  }
 

  // 返回app
  onBackApp = () => {
    var userAgent = navigator.userAgent;
    const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
    const ua = userAgent.toLowerCase();
    const isWeChat = /micromessenger/.test(ua);
    if (isWeChat) {
      // 在微信中，尝试使用小程序接口
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          wx.miniProgram.navigateBack({
            delta: 1
          })
        }
      })
    }
    if (browser.versions.android || OpenHarmony) {
      window.android.onCampusPayExit();
      return;
    }
    if (browser.versions.ios) {
      window.webkit.messageHandlers.onCampusPayExit.postMessage('');
      return;
    }
  }

  /**
    * 关闭
    */
  onSubmit = async () => {
    setTimeout(() => {
      this.onBackApp()
    }, 100);
  }

 
  

  render() {
    return (
      <div className="ysf-tip-page">
        {/* 温馨提示 */}
        <div className="tip-card">
          <div className="tip-card-title">温馨提示:</div>
          <div className="tip-card-text">一卡通免密支付的开通与关闭，请在云闪付「易校园」小程序中完成。</div>
        </div>
        {/* 底部按钮 */}
        <div className="tip-footer">
          <Button className="tip-btn" color='primary' size='large' onClick={this.onSubmit}>我知道了</Button>
        </div>
      </div>
    );
  }

}

export default YsfTipPage;